@import '~dialog-polyfill/dist/dialog-polyfill.css';
@import '~@zanichelli/albe-web-components/www/build/web-components-library.css';

:host {
  font-family: var(--font-family-sans);
  text-align: left;
}

.adv-background-overlay {
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199;
}

.adv-modal-container {
  display: flex;
  justify-content: space-between;
  background: var(--gray50);
  min-height: 300px;
  border-radius: 4px;
  border: var(--border-size-medium) solid var(--blue500);
  box-shadow: 0px 4px 8px rgba(66, 69, 72, 0.35);
  margin-left: var(--grid-margin);
  margin-right: var(--grid-margin);
}

.adv-content {
  display: flex;
  flex-direction: column;
}

.adv-content img {
  height: initial;
  width: 100%;
  max-height: 350px;
  object-fit: cover;
}

.adv-action-container {
  display: flex;
  padding: calc(var(--space-unit) * 3);
  padding-left: 0;
}

.adv-image-container {
  position: relative;
}

.adv-text-content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  line-height: calc(var(--space-unit) * 3);
  overflow: auto;
}

.adv-text-content > .adv-text > * {
  padding-left: calc(var(--space-unit) * 3);
}

.adv-text-content > h3 {
  margin: 0 0 calc(var(--space-unit) * 2);
  color: var(--gray800);
}

.adv-text-content > p {
  font-size: 1.17em;
  color: var(--gray800);
}

.adv-icon {
  fill: var(--blue500);
  display: none;
}

.adv-icon-mobile {
  fill: var(--blue500);
  position: absolute;
  top: 16px;
  right: 16px;
}

.adv-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adv-checkbox-label {
  font-size: 12px;
}

.adv-ctas {
  display: flex;
  justify-content: space-between;
  column-gap: calc(var(--space-unit) * 2);
  flex-wrap: wrap;
  margin-top: calc(var(--space-unit) * 2);
  padding-left: calc(var(--space-unit) * 3);
  padding-bottom: var(--space-unit);
  padding-right: var(--space-unit);
}

button.z-link {
  margin-top: var(--space-unit);
}

@media only screen and (max-height: 500px) {
  .adv-content img {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .adv-icon-mobile {
    display: none;
  }

  .adv-icon {
    display: block;
  }

  .adv-content {
    flex-direction: row;
  }

  .adv-content img {
    width: 250px;
    height: 400px;
    max-height: initial;
  }

  .adv-modal-container {
    height: 400px;
    width: 700px;
    overflow: hidden;
  }
}
